import Root from "../layout/Root";
import LoginForm from "../ui/LoginForm";
import InnerPage from "../layout/InnerPage";
import { BrandLogo } from "../ui/navigation/NavMenu";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../RootReducer";
import { useEffect } from "react";
import { fetchAndParseContent } from "../contenful/ContentfulActions";
import { ContentModelName } from "../contenful/types";
import { getContainer } from "../ioc/IOCSetup";
import { useHistory } from "react-router";
import { getLoggedIn } from "../selectors/user-selectors";
import { t } from "../i18n";
import "./MayaMiniAppLogin.scss";

const MayaMiniAppLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoggedIn = useSelector(getLoggedIn);
  const global = useSelector((app: AppState) => app.contentful.global);
  const loginRedirectUrl = getContainer().getSettingsService().settingsData?.loginRedirectUrl;
  const activeLocale = getContainer().getSettingsService().getActiveLocale().code;

  useEffect(() => {
    if (global != null) return;
    dispatch(fetchAndParseContent(ContentModelName.GLOBAL, activeLocale) as any);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      history.replace(loginRedirectUrl ?? "/");
    }
  }, [isLoggedIn]);

  return (
    <Root footer={false}>
      <InnerPage>
        <div className={"desktop-logo-container"} style={{ marginBottom: "2rem" }}>
          {global && <BrandLogo global={global} />}
        </div>
        <div style={{ fontSize: ".8rem", fontWeight: "bold", marginBottom: "2rem" }}>{t("mayaminiapp.login-page.description")}</div>
        <LoginForm disableInputEmail disableInputPhone />
      </InnerPage>
    </Root>
  );
};

export default MayaMiniAppLogin;
